const fonts = {
  regular: `'GT-America', system-ui, sans-serif`,
  extended: `'GT-America-Extended', system-ui, sans-serif`,
}

export default fonts
